import React from 'react';
import { bem, getDataAttr } from '../_libs/utils';
import Icon from '../icon';
import { Component, PropTypes } from '../_libs';
import './style/index.scss';
export default class Avatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: this.props.src || '',
    };
  }
  render() {
    const displayName = 'avatar';
    const { children, src, gender, size, defaultIcon } = this.props;

    const modifierClassList = {
      [bem(displayName, '', size)]: !!size,
    };

    return (
      <div
        className={this.className(bem(displayName), modifierClassList)}
        style={this.style()}
        {...getDataAttr(this.props)}>
        <Icon icon={defaultIcon} type="reverse" className={bem(displayName, 'default')} />
        {!!src && (<img
          className={bem(displayName, 'img')} onError={() => {
            this.setState({
              src: '',
            });
          }} src={this.state.src} alt="avatar" />)}
        {gender && <span className={bem(displayName, gender)}><Icon icon={gender} /></span>}
        {children}
      </div>
    );
  }
}

Avatar.defaultProps = {
  children: null,
  src: null,
  gender: null,
  size: null,
  defaultIcon: 'user',
};

Avatar.propTypes = {
  // @INTRO children
  children: PropTypes.node,
  // @INTRO 图片url
  src: PropTypes.string,
  // @INTRO 头像性别标识 || 其他识别表示（大V）
  gender: PropTypes.oneOf([
    'male',
    'female',
    'dv',
    ''
  ]),
  // @INTRO 头像尺寸
  size: PropTypes.oneOf([
    'sm',
    'md',
    'lg',
  ]),
  // @INTRO 默认图标
  defaultIcon: PropTypes.string,
};
